import * as S from './styles.ts';

interface ISliderPartProps {
  span: number;
  percentageFilled: number;
  isLast: boolean;
  altStyling?: boolean;
}

const SliderPart = ({
  span,
  percentageFilled,
  isLast,
  altStyling,
}: ISliderPartProps) => {
  return (
    <S.SliderPartWrapper $span={span}>
      <S.SliderPartContainer $altStyling={altStyling}>
        <S.SliderPartHighlighter
          style={{
            width: `calc(${percentageFilled * 100}% + ${percentageFilled && !isLast ? '4' : '0'}px)`,
          }}
        />
      </S.SliderPartContainer>
    </S.SliderPartWrapper>
  );
};

export default SliderPart;
